import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Icons } from '../../icons';
import { Button } from './Button';
export const Logout: React.FC<{
  onClick: () => void;
}> = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icons.Logout />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <Button aria-label="Logout" text="Logout" startIcon={t1} onClick={onClick} />;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};